/**
 * The template task names project initialisation recognises.
 *
 * Mirrors backend/app/core/template_task_catalog.py. A tehtävä named
 * anything else is created by no worker, so the editor only ever offers
 * names from these lists. The backend re-validates; this copy exists to
 * keep the picker honest without a round trip.
 */

export type TemplateTaskKind = "PROCUREMENT" | "INSPECTION" | "DOCUMENT";

export const PROCUREMENT_TASK_NAMES = [
  "Suunnitelmiin perehtyminen",
  "Aliurakkasopimukseen perehtyminen",
  "Aloitusedellytykset",
  "Taloudellinen loppuselvitys",
] as const;

export const INSPECTION_TASK_NAMES = [
  "Osakohteen tarkastus",
  "Malliasennustarkastus",
  "Mestan vastaanotto",
  "Työvaiheenvastaanotto",
] as const;

export const DOCUMENT_TASK_NAMES = ["Liitedokumentit"] as const;

export function allowedNames(kind: TemplateTaskKind): readonly string[] {
  if (kind === "PROCUREMENT") return PROCUREMENT_TASK_NAMES;
  if (kind === "INSPECTION") return INSPECTION_TASK_NAMES;
  return DOCUMENT_TASK_NAMES;
}

export function missingNames(
  kind: TemplateTaskKind,
  present: string[]
): string[] {
  const taken = new Set(present);
  return allowedNames(kind).filter((n) => !taken.has(n));
}
